let _ = t => t,
  _t;
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CertificationIcon } from 'foundations-assets/icons/components/CertificationIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import styledWithTheme from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StyledUnderlineOnHover = styledWithTheme.div(_t || (_t = _`
  &:hover {
    text-decoration: underline;
  }

  /* stylelint-disable-next-line value-no-vendor-prefix */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`));
export const ContentTypeBadgeMap = {
  CERTIFICATION: /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "100",
    children: [/*#__PURE__*/_jsx(CertificationIcon, {
      color: "fill-brand-default",
      size: "300"
    }), /*#__PURE__*/_jsx(Text, {
      as: "span",
      marginInlineStart: "100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.contentTypes.CERTIFICATION"
      })
    })]
  }),
  COURSE: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.contentTypes.COURSE"
  }),
  LESSON: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.contentTypes.LESSON"
  }),
  VIDEO: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.contentTypes.VIDEO"
  }),
  ACADEMY_VIDEO: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.contentTypes.ACADEMY_VIDEO"
  }),
  PLAYLIST: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.contentTypes.PLAYLIST"
  }),
  HUBSPOT_PLAYLIST: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.contentTypes.HUBSPOT_PLAYLIST"
  })
};